import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {Button} from 'front-onceforall-core';
import {useHistory} from 'react-router-dom';
import {Tooltip} from '@material-ui/core';

function RemindButtonView(props) {
  const history = useHistory();
  const {organisation} = props;

  const handleRemind = () => {
    let url = `/subcontractor/${organisation.organisationId}/remind?country=${props.country}`;
    if (props.interventionId) {
      url += `&projectName=${props.project.name}&projectId=${props.project.projectId}&interventionId=${props.interventionId}`;
    }

    history.push(url);
  };

  const button = (
    <Button
      size="large"
      type={props.primaryAction ? 'cta' : 'secondary'}
      icon="notification"
      onClick={handleRemind}
      disabled={!organisation.depositor}
      disablePointerEvents={!organisation.depositor}
    >
      {I18n.t('document.remind.command.title')}
    </Button>
  );

  return organisation.depositor ?
    <>{button}</> :
    (
      <Tooltip
        title={I18n.t('organisation.depositorService.notActivated')}
        placement="left"
      >
        <span>{button}</span>
      </Tooltip>
    );
}

RemindButtonView.propTypes = {
  organisation: PropTypes.object.isRequired,
  interventionId: PropTypes.number,
  project: PropTypes.object,
  country: PropTypes.string,
  primaryAction: PropTypes.bool
};

export default RemindButtonView;
